import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { track, useTracking } from 'lib/analytics'
import { setUserResponse } from '../../../actions'
import {
  ButtonRect,
  ButtonGroup,
} from '../../OnboardingButtons/OnboardingButtons'
import Slide from '../../Slide/Slide'
import css from './first-time-parent-slide.styles.scss'
import { urlWithChecklistParam } from 'utils'
import { useNavigate } from 'react-router-dom-v5-compat'

interface FirstTimeParentSlideProps {
  nextPath: string
  setUserResponse: (data: any) => void
}

const FirstTimeParentSlide = ({
  nextPath,
  setUserResponse,
}: FirstTimeParentSlideProps) => {
  const tracker = useTracking()
  const navigate = useNavigate()

  const url = urlWithChecklistParam(nextPath)

  const handleClick = (firstTimeParent: boolean) => {
    tracker.trackEvent({
      event: track.onboardingQuestionAnswered,
      eventLocation: track.EventLocation.ONBOARDING_MINUS_FIRST_TIME_PARENT,
      answer: firstTimeParent ? 'yes' : 'no',
    })
    setUserResponse({ firstTimeParent })
    navigate(url)
  }

  return (
    <div className={css.FirstTimeParentSlide__container}>
      <Slide title="Are you a first time parent?">
        <ButtonGroup>
          <ButtonRect
            className={css.FirstTimeParentSlide__button}
            onClick={() => handleClick(true)}
          >
            <span className={css.FirstTimeParentSlide__buttonLabel}>Yes</span>
          </ButtonRect>
          <ButtonRect
            className={css.FirstTimeParentSlide__button}
            onClick={() => handleClick(false)}
          >
            <span className={css.FirstTimeParentSlide__buttonLabel}>No</span>
          </ButtonRect>
        </ButtonGroup>
      </Slide>
    </div>
  )
}

FirstTimeParentSlide.propTypes = {
  nextPath: PropTypes.string.isRequired,
  setUserResponse: PropTypes.func.isRequired,
}

export default connect(undefined, { setUserResponse })(FirstTimeParentSlide)
